<template>
    <div class="app-container-empty">
        <el-row>
            <el-col :style="{width:'calc(30% - 25px)'}">
                <el-row>
                    <el-card class="leftCard" :style="{marginLeft:'20px'}">
                        <div slot="header">
                            <span>歌曲目录</span>
                        </div>
                        <div :style="{height:'100%'}">
                            <el-select v-model="device.dirIndex"  @change="dirSelectChange" @focus="getDir"  placeholder="请选择目录">
                                <el-option
                                        v-for="item in dirList"
                                        :key="item.dirIndex"
                                        :label="item.contentName"
                                        :value="item.dirIndex"
                                        aria-selected="true">
                                </el-option>
                            </el-select>
                            <el-radio-group   v-model="device.musicIndex"  @change="onRadioChange" v-if="musicList.length!==0">
                                <el-radio v-for="item in musicList" :key="item.audioId" :label="item.audioId" > {{item.key+'．'+item.name}}</el-radio>
                            </el-radio-group>

                            <div v-else class="emptyMusic">
                            <span>请选择目录</span>
                            </div>
                        </div>
                    </el-card>

                </el-row>
            </el-col>
            <el-col :style="{width:'calc(70% - 5px)', marginLeft:'5px'}">
                <el-row>
                    <el-card class="rightCard">
                        <div slot="header">
                            <span>设备列表</span>
                            <div class="broadcastingBtn">

                                <el-button type="primary" icon="el-icon-microphone" round @click="onVol" plain> 设置音量</el-button>
                                <!-- <el-button type="primary" icon="el-icon-phone-outline" round @click="callDevice" plain >设备寻呼</el-button> -->
                                <el-button type="primary" icon="el-icon-video-play" round @click="start" plain> 播放歌曲</el-button>
                                <el-button type="primary" icon="el-icon-video-pause" round @click="stop" plain>停止播放</el-button>
                                <el-button type="primary" icon="el-icon-refresh" round @click="reload" plain>刷新</el-button>
                            </div>
                        </div>
                        <setValue  :dialogVisible.sync="dialogVisible" :volValue="Number(device.vols)" @closeDialog="closeDialog" @setValue="setValue"> </setValue>
                        <el-table
                                :data="deviceTable"
                                border
                                highlight-current-row
                                @selection-change="handleSelectionChange"
                                :header-cell-style="{'text-align':'center'}"
                                :cell-style="{'text-align':'center'}"
                                >
                            <el-table-column prop="deviceID" type="selection"  width="50px">
                            </el-table-column>
                            <el-table-column type="index" label="序号"  width="70px">
                            </el-table-column>
                            <el-table-column label="设备名称" prop="name"  >
                            </el-table-column>
                            <!-- <el-table-column label="位置" prop="position" >
                            </el-table-column> -->
                            <el-table-column label="地址" prop="IP" >
                            </el-table-column>
                            <el-table-column label="音量" prop="vol" >
                            </el-table-column>
                            <el-table-column label="状态" prop="status" >

                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import setValue from '@/views/business/base/broadcasting/components/setValue.vue';
    import {
        // callPage,
        playMusic,
        stopMusic,
        setVol,
        showDevicesInfo,
        showMusicInfo,
    } from '@/api/business/base/tenant/audioplay'
    export default {
        components:{
            setValue,
        },
        data() {
            return {
                dialogVisible:false,
                device:[{
                    dirIndex: '',
                    musicIndex: '',
                    multipleSelection: '',
                    taskIds: '',
                    vols:0,
                }],
                dirList: [],
                musicList:[],
                deviceTable:[],
            }
        },
        created() {
            this.findDeviceInfo();
            this.getDir()
        },
        methods:{
            //在下拉框获取焦点是调用接口，获取目录和音乐列表
            getDir(){
                //判断音乐列表是否为空，如果是空的就调取数据
                if (this.dirList.length==0){
                    showMusicInfo().then(response =>{
                        console.log(response)
                        response.data.MusicInfo.DirArray
                        response.data.MusicInfo.DirArray.map((v,index)=>{
                            let str={};
                            str.dirIndex=String(index+1)
                            str.dirId=v.DirID
                            str.contentName=String(v.DirName);
                            let tempList = []
                            let audioList = []
                            response.data.MusicInfo.MusicArray.forEach(c=>{
                                if(c.DirID == str.dirId){
                                    tempList.push(c)
                                }
                            })
                            tempList.map((a, index)=>{
                                let music = {}
                                music.key=String(index+1)
                                music.name=String(a.AudioName)
                                music.audioId=a.AudioId
                                audioList.push(music)
                            })
                            str.audioList=audioList;
                            this.dirList.push(str)
                        })
                    })
                }
            },
            //目录下拉框选中
            dirSelectChange(data){
                this.device.dirIndex = data;
                this.getMusic(data)
            },
            //获取音乐列表
            getMusic(data){
                this.dirList.map(v=>{
                    if (data==v.dirIndex){
                        this.musicList=v.audioList
                    }
                })
            },
            //获取选中的音乐的index
            onRadioChange(data){
                console.log(data)
                this.device.musicIndex = data;
            },

            //获取设备数据列表
            findDeviceInfo() {
                showDevicesInfo().then(response => {
                    if(response.code === 200){
                        let deviceTempTable = []
                        response.data.forEach(data => {
                            let dataMap = {
                                taskId: data.TaskID,
                                deviceID: data.EndpointID,
                                name: data.EndpointName,
                                vol: data.Volume,
                                IP: data.EndpointIP,
                               status: data.Status == "0" ? "离线" : data.Status == "1"?"在线":"占用"
                            }
                            deviceTempTable.push(dataMap)
                        })
                        this.deviceTable = Object.assign([], deviceTempTable);
                    }
                });

            },
            //设置音量后延时获取table数据
            findDevice(){
                setTimeout( () => {
                    this.findDeviceInfo()
                }, 2000)

            },
            //table中选项框选中时发生的事件
            handleSelectionChange(data){
                console.log(data)
                let taskIds = '';
                let deviceIds = '';
                let vols=[];
                data.forEach(function (obj) {
                    if(deviceIds){
                        deviceIds += ',';
                    }
                    if(taskIds){
                        taskIds += ',';
                    }
                    taskIds += obj.taskId;
                    deviceIds +=obj.deviceID;
                    vols.push(obj.vol)
                });
                //当前选定的设备的id，
                this.device.multipleSelection = deviceIds;
                //当前选定的设备的任务id，
                this.device.taskIds = taskIds;
                //当前选定的设备的音量
                this.device.vols=vols[0];
           },
            //如果没有选择设备，弹出提示，不显示对话框
            onVol(){
                if (this.device.multipleSelection){
                    this.dialogVisible=true;
                }else {
                    this.$message('请至少选择一个');
                }
            },
            //获取到对话框的设定值，将设定值下发
            setValue(data){
                this.dialogVisible=false;
                let value= String(data)
                setVol({"terminalID": this.device.multipleSelection, "volume": value}).then(() => {
                    this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                    this.findDevice()
                })

            },
            //刷新
            reload(){
                this.findDeviceInfo();
            },
            //关闭对话框，将事件传给组件
            closeDialog(){
                this.dialogVisible=false;
            },
            //设备寻呼
            // callDevice(){
            //     if (this.device.multipleSelection) {
            //         callPage({"deviceId": this.device.multipleSelection}).then(() => {
            //             this.$message({type: 'success', message: this.$t('message.operationSuccess')});
            //             this.findDevice()
            //         })
            //     }else {
            //         this.$message('请至少选择一个');
            //     }
            // },
            //播放歌曲
            start(){
                if (this.device.multipleSelection&& this.device.dirIndex&&this.device.musicIndex){
                    playMusic({"deviceId": this.device.multipleSelection, "musicIndex": this.device.musicIndex,}).then(() => {
                        this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                        this.findDevice()
                    })
                }else {
                    this.$message('请选择音乐和设备');
                }

            },
            //停止播放
            stop(){
                console.log(this.device.taskIds)
                if(this.device.taskIds.indexOf(',') > -1){
                    this.$message('只能选择一个任务进行停止');
                } else if (this.device.taskIds) {
                    stopMusic({"taskIds": this.device.taskIds}).then(() => {
                        this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                        this.findDevice()
                    })
                }else {
                    this.$message('请至少选择一个');
                }
            },

        },
    }
</script>
<style scoped>
    .leftCard >>> .el-card__header, .rightCard >>> .el-card__header{
        padding: 20px 10px;
        line-height: 30px;
        font-size: 20px;
    }
    .leftCard >>> .el-card__body {
        height: calc(100vh - 100px);
        padding: 10px;
    }
    .rightCard >>> .el-card__body {
        padding: 10px;
        height: calc(100vh - 100px);
    }
    .el-select {
        width: 100%;
    }
    .el-select /deep/ .el-input__inner{
        height: 45px;
    }
    .el-table {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    .el-button--info {
        border-color: #909399;
    }
</style>
<style lang="scss">

    .emptyMusic {
        border: 1px solid rgb(169, 169, 169);
        height: 85%;
        width: 100%;
        margin-top: 5px;
        font-size: 30px;
        text-align: center;
        padding-top: 100px;
    }
    .el-radio-group {
        border: 1px solid rgb(169, 169, 169);
        height: 85%;
        width: 100%;
        overflow-y: scroll;
        margin-top: 5px;

        .el-radio {
            display: block;
            padding: 5px;
            width: 100%;

            &.is-checked {
                background-color: #409EFF;

                .el-radio__label {
                    color: white;
                }
            }

            .el-radio__input {
                display: none;
            }
        }
    }
    .broadcastingBtn {
        float: right;
        margin-right: 10px;
        .el-button {
            padding: 10px 10px;
        }
    }

</style>